var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isLoading)?_c('div',{staticClass:"home-spinner-container"},[_c('b-spinner')],1):_c('div',[_c('Navbar'),_c('Nav'),_c('div',{staticClass:"page-wrapper"},[(_vm.$route.meta.breadcrumb)?_c('b-breadcrumb',{attrs:{"items":_vm.$route.meta.breadcrumb}}):_vm._e()],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }